const Styles = {
  containerStyle: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  informationContainerStyle: {
    display: 'flex',
    width: '35%',
    backgroundColor: '#3B424D',
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: 15,
    paddingRight: 15
  },
  informationItemsContainerStyle: {
    display: 'flex',
    flex: 1,
    paddingTop: 128,
    flexDirection: 'column',
    paddingLeft: 40,
    paddingRight: 40
  },
  textStyle: {
    color: '#f4f4f8'
  },
  itemContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 25
  },
  innerItemContainerStyle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1
  },
  itemHeaderStyle: {
    margin: 0,
    fontSize: 14,
    fontWeight: 600
  },
  itemTextStyle: {
    margin: 0,
    fontSize: 20,
    fontWeight: 300,
    wordBreak: 'break-word'
  },
  iconContainerStyle: {
    display: 'flex',
    width: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 25
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/pages/communityInformation/CommunityInformation/styles.js